const UPLOAD_URL = '/api/upload.php';

const toSizeLabel = (size = 0) => {
  if (!size || Number.isNaN(Number(size))) return '';
  const kb = Math.max(1, Math.round(Number(size) / 1024));
  return `${kb} KB`;
};

const normalize = (value, fallback = 'general') => {
  const text = `${value || ''}`.trim();
  return text || fallback;
};

const buildDateSegment = (value) => {
  if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  return new Date().toISOString().slice(0, 10);
};

export async function uploadStoredAttachment(file, uploadedBy = 'System', context = {}) {
  if (!file) return null;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('uploadedBy', normalize(uploadedBy, 'System'));
  formData.append('entityType', normalize(context.entityType, 'general'));
  formData.append('entityId', normalize(context.entityId, 'unassigned'));
  formData.append('entityName', normalize(context.entityName, 'unassigned'));
  formData.append('category', normalize(context.category, 'general'));
  formData.append('documentType', normalize(context.documentType, 'attachment'));
  formData.append('dateSegment', buildDateSegment(context.dateSegment));

  const response = await fetch(UPLOAD_URL, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin'
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload?.ok || !payload?.file) {
    throw new Error(payload?.error || 'Upload failed.');
  }

  return {
    id: payload.file.id,
    name: payload.file.name || file.name || 'Attachment',
    type: payload.file.type || file.type || 'file',
    size: toSizeLabel(payload.file.sizeBytes || file.size || 0),
    sizeBytes: payload.file.sizeBytes || file.size || 0,
    fileUrl: payload.file.fileUrl || '',
    relativePath: payload.file.relativePath || '',
    uploadedAt: payload.file.uploadedAt || new Date().toISOString(),
    uploadedBy
  };
}

export async function uploadStoredAttachments(fileList, uploadedBy = 'System', context = {}) {
  const files = Array.from(fileList || []);
  if (files.length === 0) return [];
  return Promise.all(files.map((file) => uploadStoredAttachment(file, uploadedBy, context)));
}
